import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { resendRegisterOtp, verifyOTPRegister } from "../../services/auth.services";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import OtpInput from "react-otp-input";
import logo from "../../../../assets/Discount_App_logo.png";
import * as Yup from "yup";

function BusinessRegisterVerifyOTP() {
  const navigate = useNavigate();
  const location = useLocation();
  const [emailOTP, setEmailOtp] = useState("");
  const [phoneOTP, setPhoneOTP] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [counter, setCounter] = useState(0);

  const validationSchema = Yup.object().shape({
    email_otp: Yup.string().length(6, "Email OTP must be 6 digits").required("Email OTP is required"),
    // phone_otp: Yup.string().length(6, "Phone OTP must be 6 digits").required("Phone OTP is required"),
  });

  const formik = useFormik({
    initialValues: {
      email_otp: "",
      phone_otp: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      globalLoader(true);
      const formData = new FormData();
      formData.append("email", location?.state?.email);
      // formData.append("phone_number", location?.state?.phone_number);
      // formData.append("phone_number", JSON.stringify(location?.state?.phone_number));
      formData.append("email_otp", values.email_otp);
      // formData.append("phone_otp", values.phone_otp);
      verifyOTPRegister(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            navigate("/business/register-thanks-page");
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("error--->", error);
        });
    },
  });

  useEffect(() => {
    if (resendDisabled) {
      const timer = setInterval(() => {
        setCounter((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendDisabled]);

  const handleResend = () => {
    setEmailOtp("");
    // setPhoneOTP("");
    setCounter(60);
    setResendDisabled(true);
    const formData = new FormData();
    formData.append("email", location?.state?.email);
    // formData.append("phone_number", JSON.stringify(location?.state?.phone_number));
    resendRegisterOtp(formData)
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  return (
    <div className="container section-section">
      <div className="back-button">
        <Link to={"/business/register"} className="d-flex align-items-center gap-2">
          <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
        </Link>
      </div>

      <div className="verification-wrapper text-center">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        <form onSubmit={formik.handleSubmit} className="mt-2">
{/* 
          <div className="heading-text-auth mb-4">
            <h4 className="h3-headline">Verify Your Phone</h4>
            <p className="subtitle-1 text mt-2">Enter the 6-digit code we sent on your phone</p>
          </div>

          <OtpInput
            value={phoneOTP}
            onChange={(value) => {
              setPhoneOTP(value);
              formik.setFieldValue("phone_otp", value);
            }}
            numInputs={6}
            isInputNum
            shouldAutoFocus
            containerStyle="otp-phone d-flex justify-content-center"
            inputStyle="vartical form-control text-center"
            renderInput={(props, index) => <input {...props} key={index} className="vartical form-control text-center" maxLength="1" />}
          />
          {formik.errors.phone_otp && formik.touched.phone_otp && <div className="text-danger mt-2">{formik.errors.phone_otp}</div>}

*/}

          <div className="email-otp-heading mt-5">
            <div className="heading-text-auth mb-4">
              <h4 className="h3-headline">Verify Your Email</h4>
              <p className="subtitle-1 text mt-2">Enter the 6-digit code we sent on your email.</p>
            </div>

            <OtpInput
              value={emailOTP}
              onChange={(value) => {
                setEmailOtp(value);
                formik.setFieldValue("email_otp", value);
              }}
              numInputs={6}
              isInputNum
              containerStyle="otp-phone d-flex justify-content-center"
              inputStyle="vartical form-control text-center"
              renderInput={(props, index) => <input {...props} key={index} className="vartical form-control text-center" maxLength="1" />}
            />
            {formik.errors.email_otp && formik.touched.email_otp && <div className="text-danger mt-2">{formik.errors.email_otp}</div>}
          </div>

          <div className="col-md-12 text-center mt-3">
            <button type="submit" className="btn btn-light-purple px-5">
              Continue
            </button>
          </div>

          <div className="body-2 form-last-text mt-4 text-center" htmlFor="agreeCheck">
            Didn’t get a code?{" "}
            {resendDisabled ? (
              <a href="#" className="subtitle-2">
                Resend in {counter}s
              </a>
            ) : (
              <a
                href="#"
                className="subtitle-2  ms-2"
                onClick={(e) => {
                  e.preventDefault();
                  handleResend();
                }}>
                Resend OTP
              </a>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default BusinessRegisterVerifyOTP;
